import type { Reactive } from '../types'

export function originTrigger(target: any, key: number | string): void
export function originTrigger(target: Reactive, key: number | string): void {
  const signal = target.__rr_signals?.[key]
  if (signal !== undefined) signal.value = NaN
}
